import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { actionWeeklyReportLoadData } from './actions';
import { NAMESPACE } from './helpers';
import { WeeklyReportFilters, WeeklyReportItem } from '../models';

interface State {
  isLoading: boolean;
  isInit: boolean;
  isMounted: boolean;
  filters: WeeklyReportFilters;
  data: WeeklyReportItem[];
}

export const initialState = (): State => {
  return {
    isLoading: false,
    isInit: false,
    isMounted: false,
    filters: {
      done: false,
      year: new Date().getFullYear(),
    },
    data: [],
  };
};

const slice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    updateFilters: (state, action: PayloadAction<Partial<WeeklyReportFilters>>) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    init: (state) => {
      state.isMounted = true;
    },
    destroy: (state) => {
      state.isMounted = false;
    },
  },
  extraReducers(build) {
    build
      .addCase(actionWeeklyReportLoadData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(actionWeeklyReportLoadData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(actionWeeklyReportLoadData.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});
export const weeklyReportReducer = slice.reducer;
export const weeklyReportActions = slice.actions;
